import { html } from '@ensemble.music/ui'
import { Music } from 'lucide-react'
import { motion } from 'motion/react'
import { ensembleTerms } from './content'

// The chips rise in one after another when the list scrolls into view and sink out again when it
// leaves (owner request 2026-10-20). Transform and opacity only, so the grow-on-hover in
// .landing-term (padding, font size) is untouched; MotionConfig reducedMotion="user" on the page
// drops the transform for people who ask for less motion.
const list = {
  hidden: { transition: { staggerChildren: 0.02, staggerDirection: -1 } },
  shown: { transition: { staggerChildren: 0.04 } },
}
const chip = {
  hidden: { opacity: 0, y: 16, scale: 0.92 },
  shown: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.3, ease: 'easeOut' as const } },
}

/** The umbrella word and what it covers, on /fuer-ensembles (owner, 2026-10-20). */
export function EnsembleTerms() {
  return (
    <html.section className="flex flex-col items-center gap-10 py-16 max-sm:gap-8 max-sm:py-8">
      {/* Icon beside the heading, heading and lead left-aligned to it, the group centred. */}
      <html.div className="flex flex-row items-start gap-5 max-w-[760px] max-sm:gap-4">
        <html.span className="inline-flex flex-row items-center justify-center shrink-0 w-14 h-14 rounded-2xl bg-background-muted text-color max-sm:w-11 max-sm:h-11">
          <Music
            size={28}
            aria-hidden="true"
          />
        </html.span>
        <html.div className="flex flex-col gap-3">
          <html.h2 className="text-3xl font-semibold tracking-tight text-color max-sm:text-2xl">
            {ensembleTerms.title}
          </html.h2>
          <html.p className="text-lg text-color-secondary">{ensembleTerms.lead}</html.p>
        </html.div>
      </html.div>
      {/* Plain <ul>/<li>: an html.li cannot take a bare text child (react-native-web), and the
          grow-on-hover lives in the .landing-term rule in style.css. */}
      <motion.ul
        className="landing-terms"
        variants={list}
        initial="hidden"
        whileInView="shown"
        viewport={{ amount: 0.4 }}
      >
        {ensembleTerms.terms.map((term) => (
          <motion.li
            key={term}
            className="landing-term"
            variants={chip}
          >
            {term}
          </motion.li>
        ))}
      </motion.ul>
    </html.section>
  )
}
